document.addEventListener("DOMContentLoaded", function () {
  function getWishlist() {
    return JSON.parse(localStorage.getItem('wishlist')) || [];
  }

  function saveWishlist(wishlist) {
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
  }

  function isInWishlist(handle) {
    return getWishlist().includes(handle);
  }

  function updateWishlistCount() {
    const count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const count = cart.item_count;
        document.querySelectorAll('.cart-link__count').forEach(el => {
          el.textContent = count;
        });
      });
  }

  function toggleWishlist(handle) {
    let wishlist = getWishlist();
    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(item => item !== handle);
    } else {
      wishlist.push(handle);
    }
    saveWishlist(wishlist);
    updateWishlistCount();
  }

  function bindWishlistButtons(scope = document) {
    const wishlistButtons = scope.querySelectorAll('.wishlist-button');

    wishlistButtons.forEach(button => {
      const handle = button.dataset.productHandle;
      if (!handle) return;

      button.classList.toggle('active', isInWishlist(handle));

      if (!button.dataset.bound) {
        button.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          toggleWishlist(handle);
          button.classList.toggle('active');
        });
        button.dataset.bound = "true";
      }
    });
  }

  // Initial setup
  updateWishlistCount();
  bindWishlistButtons();

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (node.matches('.product-recommendations') || node.querySelector('.wishlist-button')) {
            bindWishlistButtons(node);
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  const wishlistPage = document.getElementById('wishlist-page');
  if (wishlistPage) {
    const container = document.getElementById('wishlist-products');
    const wishlist = getWishlist();

    if (!wishlist.length) {
      container.innerHTML = "<p>Your wishlist is empty.</p>";
      return;
    }

    container.innerHTML = '<p>Loading your wishlist...</p>';

    Promise.all(
      wishlist.map(handle =>
        fetch(`/products/${handle}.js`)
          .then(res => res.ok ? res.json() : null)
          .catch(() => null)
      )
    ).then(products => {
      const validProducts = products.filter(Boolean);
      if (!validProducts.length) {
        container.innerHTML = '<p>No valid products found in your wishlist.</p>';
        return;
      }

      container.innerHTML = '';

      validProducts.forEach(product => {
        const price = (product.price / 100).toFixed(2);
        const html = `
          <div class="wishlist-item" data-handle="${product.handle}">
            <a href="${product.url}" class="wishlist-link">
              <img src="${product.images[0]}" alt="${product.title}" class="wishlist-image" />
              <h3>${product.title}</h3>
              <p>$${price}</p>
            </a>
            <div class="wishlist-actions">
              <button class="wishlist-move-cart" data-id="${product.variants[0].id}">Move to Cart</button>
              <button class="wishlist-delete-icon" data-handle="${product.handle}" title="Remove from Wishlist">
                <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 64 64">
                  <path d="M 28 11 C 26.895 11 26 11.895 26 13 L 26 14 L 13 14 C 11.896 14 11 14.896 11 16 C 11 17.104 11.896 18 13 18 L 14.160156 18 L 16.701172 48.498047 C 16.957172 51.583047 19.585641 54 22.681641 54 L 41.318359 54 C 44.414359 54 47.041828 51.583047 47.298828 48.498047 L 49.839844 18 L 51 18 C 52.104 18 53 17.104 53 16 C 53 14.896 52.104 14 51 14 L 38 14 L 38 13 C 38 11.895 37.105 11 36 11 L 28 11 z M 18.173828 18 L 45.828125 18 L 43.3125 48.166016 C 43.2265 49.194016 42.352313 50 41.320312 50 L 22.681641 50 C 21.648641 50 20.7725 49.194016 20.6875 48.166016 L 18.173828 18 z"></path>
                </svg>
              </button>
            </div>
          </div>
        `;
        container.insertAdjacentHTML('beforeend', html);
      });

      // Handle Move to Cart
      document.querySelectorAll('.wishlist-move-cart').forEach(button => {
        button.addEventListener('click', function () {
          const variantId = this.dataset.id;
          const itemEl = this.closest('.wishlist-item');
          const handle = itemEl.dataset.handle;

          // Show loading state
          button.disabled = true;
          const originalText = button.innerHTML;
          button.innerHTML = 'Moving...';


          // button.disabled = true;
          // button.innerHTML = loaderSVG;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          })
            .then(res => res.json())
            .then(() => {
              toggleWishlist(handle);
              itemEl.remove();
              updateWishlistCount();

              fetch('/?sections=sections--17738718183563__cart-drawer')
                .then(res => res.json())
                .then(data => {
                  const newDrawerHTML = data['sections--17738718183563__cart-drawer'];
                  const newDrawer = new DOMParser().parseFromString(newDrawerHTML, 'text/html').body.firstElementChild;
                  const oldDrawer = document.querySelector('cart-drawer');
                  if (oldDrawer && newDrawer) {
                    oldDrawer.replaceWith(newDrawer);
                    if (!newDrawer.hasAttribute('open')) {
                      newDrawer.setAttribute('open', '');
                    }
                    newDrawer.scrollTop = 0;
                  }
                  updateCartCount();
                });

              if (getWishlist().length === 0) {
                container.innerHTML = "<p>Your wishlist is empty.</p>";
              }
            })
            .catch(err => {
              console.error('Add to cart failed', err);
              alert("Failed to add to cart.");
              button.disabled = false;
              button.innerHTML = "Move to Cart";
            });
        });
      });

      // Handle delete button
      document.querySelectorAll('.wishlist-delete-icon').forEach(button => {
        button.addEventListener('click', function () {
          const handle = this.dataset.handle;
          const itemEl = this.closest('.wishlist-item');

          const loader = `
            <svg width="60" height="60" viewBox="0 0 38 38"><g transform="translate(19 19)"><g transform="rotate(0)">
              <circle cx="0" cy="12" r="3" fill="#DC143C" opacity="0.125"><animate attributeName="opacity" dur="1.2s" begin="0s" repeatCount="indefinite" keyTimes="0;1" values="1;0.125"/></circle>
              <circle cx="0" cy="12" r="3" fill="#DC143C" opacity="1" transform="rotate(315)"><animate attributeName="opacity" dur="1.2s" begin="1.05s" repeatCount="indefinite" keyTimes="0;1" values="1;1"/></circle>
            </g></g></svg>`;

          button.disabled = true;
          const original = button.innerHTML;
          button.innerHTML = loader;

          setTimeout(() => {
            toggleWishlist(handle);
            itemEl.remove();
            updateWishlistCount();
            if (getWishlist().length === 0) {
              container.innerHTML = "<p>Your wishlist is empty.</p>";
            }
          }, 300);
        });
      });
    });
  }
});
